module.exports = __webpack_public_path__ + "5398bffcf8cd77a4d30b9b5cf97508ab.svg";